import { render, staticRenderFns } from "./ManageExpense.vue?vue&type=template&id=c44d51ea&scoped=true"
import script from "./ManageExpense.vue?vue&type=script&lang=js"
export * from "./ManageExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44d51ea",
  null
  
)

export default component.exports